import styled from 'styled-components';

export const StyledCardTitle = styled.div`
  color: #2f2f35;
  font-family: Poppins, sans-serif;
  font-size: ${(props) => props.fontSize};
  font-style: normal;
  /* width: 100%; */
  font-weight: 600;
  line-height: normal;
  text-overflow: ellipsis;
  text-align: left;
`;
